<template>
    <div class="agenda2030-icons text-lg-right">
        <a v-for="icon in agenda2030Icons" :href="icon.link" target="_blank">
            <img class="agenda2030-icon" :src="icon.iconPath" :alt="icon.altText" :title="icon.altText" />
        </a>
    </div>
</template>
<script>
    const iconPath = "/hankeikkuna-government-timeline/resources/img/";
    const altTextPrefixFi = "Toteuttaa YK:n kestävän kehityksen toimintaohjelman tavoitetta: ";
    const altTextPrefixSv = "Toteuttaa YK:n kestävän kehityksen toimintaohjelman tavoitetta (sv): ";
    const altTextPrefixEn = "Toteuttaa YK:n kestävän kehityksen toimintaohjelman tavoitetta (en): ";

    const agendaIconMap = {
        "http://www.yso.fi/onto/juho/p14162": {
            icon: {
                fi: iconPath + "FI01_koyhyys.jpg",
                sv: iconPath + "SV01_fattigdom.jpg",
                en: iconPath + "EN01_poverty.jpg"
            },
            altText: {
                fi: altTextPrefixFi + "Ei köyhyyttä",
                sv: altTextPrefixSv + "Ingen fattigdom",
                en: altTextPrefixEn + "No poverty"
            },
            link: {
                fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-1",
                sv: "https://kestavakehitys.fi/sv/agenda2030/mal-1",
                en: "https://kestavakehitys.fi/en/agenda2030/goal-1"
            }
        },
        "http://www.yso.fi/onto/juho/p14159": {
            icon: {
                fi: iconPath + "FI02_nalka.jpg",
                sv: iconPath + "SV02_hunger.jpg",
                en: iconPath + "EN02_hunger.jpg"
            },
            altText: {
                fi: altTextPrefixFi + "Ei nälkää",
                sv: altTextPrefixSv + "Ingen hunger",
                en: altTextPrefixEn + "Zero hunger"
            },
            link: {
              fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-2",
              sv: "https://kestavakehitys.fi/sv/agenda2030/mal-2",
              en: "https://kestavakehitys.fi/en/agenda2030/goal-2"
            }
        },
        "http://www.yso.fi/onto/juho/p14152": {
            icon: {
                fi: iconPath + "FI03_terveys.jpg",
                sv: iconPath + "SV03_halsa.jpg",
                en: iconPath + "EN03_health.jpg"
            },
            altText: {
                fi: altTextPrefixFi + "Terveyttä ja hyvinvointia",
                sv: altTextPrefixSv + "Hälsä och välbefinnande",
                en: altTextPrefixEn + "Good health and well-being"
            },
            link: {
              fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-3",
              sv: "https://kestavakehitys.fi/sv/agenda2030/mal-3",
              en: "https://kestavakehitys.fi/en/agenda2030/goal-3"
            }
        },
        "http://www.yso.fi/onto/juho/p14161": {
            icon: {
                fi: iconPath + "FI04_koulutus.jpg",
                sv: iconPath + "SV04_utbildning.jpg",
                en: iconPath + "EN04_education.jpg"
            },
            altText: {
                fi: altTextPrefixFi + "Hyvä koulutus",
                sv: altTextPrefixSv + "God utbildning för alla",
                en: altTextPrefixEn + "Quality education"
            },
            link: {
              fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-4",
              sv: "https://kestavakehitys.fi/sv/agenda2030/mal-4",
              en: "https://kestavakehitys.fi/en/agenda2030/goal-4"
            }
        },
        "http://www.yso.fi/onto/juho/p14155": {
            icon: {
                fi: iconPath + "FI05_tasa-arvo.jpg",
                sv: iconPath + "SV05_jamstalldhet.jpg",
                en: iconPath + "EN05_gender.jpg"
            },
            altText: {
                fi: altTextPrefixFi + "Sukupuolten tasa-arvo",
                sv: altTextPrefixSv + "Jämställdhet",
                en: altTextPrefixEn + "Gender equality"
            },
            link: {
              fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-5",
              sv: "https://kestavakehitys.fi/sv/agenda2030/mal-5",
              en: "https://kestavakehitys.fi/en/agenda2030/goal-5"
            }
        },
        "http://www.yso.fi/onto/juho/p14145": {
            icon: {
                fi: iconPath + "FI06_vesi_ja_sanitaatio.jpg",
                sv: iconPath + "SV06_vatten_och_sanitet.jpg",
                en: iconPath + "EN06_water_and_sanitation.jpg"
            },
            altText: {
                fi: altTextPrefixFi + "Puhdas vesi ja sanitaatio",
                sv: altTextPrefixSv + "Rent vatten och sanitet",
                en: altTextPrefixEn + "Clean water and sanitation"
            },
            link: {
              fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-6",
              sv: "https://kestavakehitys.fi/sv/agenda2030/mal-6",
              en: "https://kestavakehitys.fi/en/agenda2030/goal-6"
            }
        },
        "http://www.yso.fi/onto/juho/p14158": {
            icon: {
                fi: iconPath + "FI07_energia.jpg",
                sv: iconPath + "SV07_energi.jpg",
                en: iconPath + "EN07_energy.jpg"
            },
            altText: {
                fi: altTextPrefixFi + "Edullista ja puhdasta energiaa",
                sv: altTextPrefixSv + "Hällbar energi för alla",
                en: altTextPrefixEn + "Affordable and clean energy"
            },
            link: {
              fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-7",
              sv: "https://kestavakehitys.fi/sv/agenda2030/mal-7",
              en: "https://kestavakehitys.fi/en/agenda2030/goal-7"
            }
        },
        "http://www.yso.fi/onto/juho/p14143": {
            icon: {
                fi: iconPath + "FI08_tyo_ja_talouskasvu.jpg",
                sv: iconPath + "SV08_arbet_och_ekonomi.jpg",
                en: iconPath + "EN08_work_and_economy.jpg"
            },
            altText: {
                fi: altTextPrefixFi + "Ihmisarvoista työtä ja talouskasvua",
                sv: altTextPrefixSv + "Anständiga arbetsvillkor och ekonomisk tillväxt",
                en: altTextPrefixEn + "Decent work and economic growth"
            },
            link: {
              fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-8",
              sv: "https://kestavakehitys.fi/sv/agenda2030/mal-8",
              en: "https://kestavakehitys.fi/en/agenda2030/goal-8"
            }
        },
        "http://www.yso.fi/onto/juho/p14146": {
            icon: {
                fi: iconPath + "FI09_teollisuus_ja_infra.jpg",
                sv: iconPath + "SV09_industri_och_infrastruktur.jpg",
                en: iconPath + "EN09_industry_and_infrastructure.jpg"
            },
            altText: {
                fi: altTextPrefixFi + "Kestävää teollisuutta, innovaatioita ja infrastruktuureja",
                sv: altTextPrefixSv + "Hällbar industri, innovationer och infrastruktur",
                en: altTextPrefixEn + "Industry, innovation and infrastructure"
            },
            link: {
              fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-9",
              sv: "https://kestavakehitys.fi/sv/agenda2030/mal-9",
              en: "https://kestavakehitys.fi/en/agenda2030/goal-9"
            }
        },
        "http://www.yso.fi/onto/juho/p14151": {
            icon: {
                fi: iconPath + "FI10_eriarvoisuus.jpg",
                sv: iconPath + "SV10_ojamlikhet.jpg",
                en: iconPath + "EN10_inequalities.jpg"
            },
            altText: {
                fi: altTextPrefixFi + "Eriarvoisuuden vähentäminen",
                sv: altTextPrefixSv + "Minskad ojämlikhet",
                en: altTextPrefixEn + "Reduced inequalities"
            },
            link: {
              fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-10",
              sv: "https://kestavakehitys.fi/sv/agenda2030/mal-10",
              en: "https://kestavakehitys.fi/en/agenda2030/goal-10"
            }
        },
        "http://www.yso.fi/onto/juho/p14144": {
            icon: {
                fi: iconPath + "FI11_kestavat_kaupungit.jpg",
                sv: iconPath + "SV11_stader.jpg",
                en: iconPath + "EN11_cities.jpg"
            },
            altText: {
                fi: altTextPrefixFi + "Kestävät kaupungit ja yhteisöt",
                sv: altTextPrefixSv + "Hällbara städer och samhällen",
                en: altTextPrefixEn + "Sustainable cities and communities"
            },
            link: {
              fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-11",
              sv: "https://kestavakehitys.fi/sv/agenda2030/mal-11",
              en: "https://kestavakehitys.fi/en/agenda2030/goal-11"
            }
        },
        "http://www.yso.fi/onto/juho/p14157": {
            icon: {
                fi: iconPath + "FI12_vastuullinen_kulutus.jpg",
                sv: iconPath + "SV12_konsumption.jpg",
                en: iconPath + "EN12_consumption.jpg"
            },
            altText: {
                fi: altTextPrefixFi + "Vastuullista kuluttamista",
                sv: altTextPrefixSv + "Hällbar konsumtion och produktion",
                en: altTextPrefixEn + "Responsible consumption and production"
            },
            link: {
              fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-12",
              sv: "https://kestavakehitys.fi/sv/agenda2030/mal-12",
              en: "https://kestavakehitys.fi/en/agenda2030/goal-12"
            }
        },
        "http://www.yso.fi/onto/juho/p14156": {
            icon: {
                fi: iconPath + "FI13_ilmastotekoja.jpg",
                sv: iconPath + "SV13_klimat.jpg",
                en: iconPath + "EN13_climate.jpg",
            },
            altText: {
                fi: altTextPrefixFi + "Ilmastotekoja",
                sv: altTextPrefixSv + "Bekämpa klimatförändringarna",
                en: altTextPrefixEn + "Climate action"
            },
            link: {
              fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-13",
              sv: "https://kestavakehitys.fi/sv/agenda2030/mal-13",
              en: "https://kestavakehitys.fi/en/agenda2030/goal-13"
            }
        },
        "http://www.yso.fi/onto/juho/p14147": {
            icon: {
                fi: iconPath + "FI14_vedenalainen_elama.jpg",
                sv: iconPath + "SV14_hav_och_marina_resurser.jpg",
                en: iconPath + "EN14_life_below_water.jpg",
            },
            altText: {
                fi: altTextPrefixFi + "Vedenalainen elämä",
                sv: altTextPrefixSv + "Hav och marina resurser",
                en: altTextPrefixEn + "Life below water"
            },
            link: {
              fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-14",
              sv: "https://kestavakehitys.fi/sv/agenda2030/mal-14",
              en: "https://kestavakehitys.fi/en/agenda2030/goal-14"
            }
        },
        "http://www.yso.fi/onto/juho/p14141": {
            icon: {
                fi: iconPath + "FI15_maanpaallinen_elama.jpg",
                sv: iconPath + "SV15_ekosystem.jpg",
                en: iconPath + "EN15_life_on_land.jpg"
            },
            altText: {
                fi: altTextPrefixFi + "Maanpäällinen elämä",
                sv: altTextPrefixSv + "Ekosystem och biologisk mångfald",
                en: altTextPrefixEn + "Life on land"
            },
            link: {
              fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-15",
              sv: "https://kestavakehitys.fi/sv/agenda2030/mal-15",
              en: "https://kestavakehitys.fi/en/agenda2030/goal-15"
            }
        },
        "http://www.yso.fi/onto/juho/p14154": {
            icon: {
                fi: iconPath + "FI16_rauha_ja_hyva_hallinto.jpg",
                sv: iconPath + "SV16_fredliga_samhallen.jpg",
                en: iconPath + "EN16_peace_and_institutions.jpg"
            },
            altText: {
                fi: altTextPrefixFi + "Rauha, oikeudenmukaisuus ja hyvä hallinto",
                sv: altTextPrefixSv + "Fredliga och inkluderande samhällen",
                en: altTextPrefixEn + "Peace, justice and strong institutions"
            },
            link: {
              fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-16",
              sv: "https://kestavakehitys.fi/sv/agenda2030/mal-16",
              en: "https://kestavakehitys.fi/en/agenda2030/goal-16"
            }
        },
        "http://www.yso.fi/onto/juho/p14153": {
            icon: {
                fi: iconPath + "FI17_kumppanuus.jpg",
                sv: iconPath + "SV17_partnerskap.jpg",
                en: iconPath + "EN17_partnerships.jpg"
            },
            altText: {
                fi: altTextPrefixFi + "Yhteistyö ja kumppanuus",
                sv: altTextPrefixSv + "Genomförande och globalt partnerskap",
                en: altTextPrefixEn + "Partnerships for the goals"
            },
            link: {
              fi: "https://kestavakehitys.fi/web/kestava-kehitys/agenda2030/tavoite-17",
              sv: "https://kestavakehitys.fi/sv/agenda2030/mal-17",
              en: "https://kestavakehitys.fi/en/agenda2030/goal-17"
            }
        }
    }

    export default {
        props: {
            valitavoite: Object,
            jsonApi: String,
        },
        computed: {
            agenda2030Icons() {
              return this.valitavoite.asiasanat
                  .map(asiasana => {
                      const iconByLocale = agendaIconMap[asiasana.uri];
                      if (iconByLocale) {
                          const iconPath = iconByLocale.icon[this.$translate.current]
                          if (iconPath) {
                              return {
                                  asiasana: asiasana,
                                  altText: iconByLocale.altText[this.$translate.current],
                                  iconPath: this.jsonApi + iconPath,
                                  link: iconByLocale.link[this.$translate.current]
                              }
                          }
                      }
                      return null;
                  })
                  .filter(it => it)
                  .sort((iconData1, iconData2) => iconData1.iconPath.localeCompare(iconData2.iconPath));
            }
        }
    }
</script>